import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { header } from "./header";
import { auctionResultDistribution_template } from "../components/templates/auctionResultDistribution_template";
import { getListResultsElement, startListLoading, stopListLoading, } from "~/utils/listLoading";
export class auctionResultDistribution extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.listRequestGeneration = 0;
    }
    getModuleName() {
        return "auction_result_distribution";
    }
    cleanup() {
        this.tpl?.destroyDatePickerCalendar?.();
    }
    internalLoad(container) {
        this.build();
        this.insertIn(container);
        for (const element of this.content) {
            try {
                ko.applyBindings(this.viewModel, element);
            }
            catch (error) {
                console.error("Knockout binding failed for", element.id, error);
            }
        }
        this.loadSavedViewModule();
        try {
            this.fillPage();
        }
        finally {
            container.classList.remove("loading");
        }
    }
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle("Auction Result Distribution");
        loadedModule.setBreadcrumbs([
            { label: "Home", href: "/home", icon: "home" },
            { label: "Auction Result Distribution", href: null },
        ]);
        this.tpl = new auctionResultDistribution_template("auctionResultDistribution_template", this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    fillPage() {
        try {
            this.tpl.buildDatePickerCalendar();
            this.getListFormData();
        }
        catch (error) {
            console.error(error);
            this.stopListLoading();
        }
    }
    getListResultsElement() {
        return getListResultsElement(this.tpl?.builtTemplate);
    }
    startListLoading() {
        startListLoading(this, this.tpl?.builtTemplate);
    }
    stopListLoading() {
        stopListLoading(this, this.tpl?.builtTemplate);
    }
    getListFormData() {
        this.startListLoading();
        this.requestHandler = new XMLHttpRequestHandler("/api/auctionResultDistribution/references/", [], this);
        this.requestHandler.onReadyStateFunction = this.onFilterRequestReturn;
        this.requestHandler.execute();
    }
    onFilterRequestReturn(req, obj) {
        return function () {
            if (req.request.readyState !== 4) {
                return;
            }
            try {
                obj.manageResponse(req, obj, function () {
                    if (req.request.status !== 200) {
                        return;
                    }
                    try {
                        const responseParsed = JSON.parse(req.request.response || "{}");
                        obj.updateFilters(responseParsed);
                        obj.updateViewModelFromPath();
                        obj.getData();
                    }
                    catch (error) {
                        console.error(error);
                        obj.stopListLoading();
                    }
                });
            }
            catch (error) {
                console.error(error);
                obj.stopListLoading();
            }
            finally {
                if (req.request.status !== 200) {
                    obj.stopListLoading();
                }
            }
        };
    }
    updateFilters(responseParsed) {
        this.tpl.setBrandFilterItems(responseParsed?.brands);
        this.tpl.setProductFilterItems(responseParsed?.products);
        this.tpl.setTrafficFilterItems(responseParsed?.trafficSources);
        this.tpl.setChannelFilterItems(responseParsed?.channels);
        this.tpl.setDeviceFilterItems(responseParsed?.devices);
        this.tpl.setFormVariantFilterItems(responseParsed?.formVariants);
        this.tpl.setAudienceFilterItems(responseParsed?.audiences);
        this.tpl.setClickAuctionExperimentFilterItems(responseParsed?.clickAuctionExperiments);
        this.tpl.setLeadAuctionExperimentFilterItems(responseParsed?.leadAuctionExperiments);
    }
    getData() {
        const generation = ++this.listRequestGeneration;
        this.startListLoading();
        try {
            const subViewModel = this.tpl.getViewModelForRequest();
            const baseApiUrl = "/api/auctionResultDistribution/get/";
            this.sendFilterCall(baseApiUrl, subViewModel, this.onDataRequestReturn(generation), XMLHttpRequestHandler_requestType.GET, "getData");
        }
        catch (error) {
            console.error(error);
            this.stopListLoading();
        }
    }
    onDataRequestReturn(generation) {
        return (req, obj) => {
            return function () {
                if (req.request.readyState !== 4) {
                    return;
                }
                try {
                    obj.manageResponse(req, obj, function () {
                        if (req.request.status !== 200) {
                            return;
                        }
                        const responseParsed = JSON.parse(req.request.response || "{}");
                        obj.tpl.setStatus(responseParsed?.status);
                        obj.tpl.setListData(responseParsed?.listData ?? []);
                    });
                }
                catch (error) {
                    console.error(error);
                }
                finally {
                    if (generation === obj.listRequestGeneration) {
                        obj.stopListLoading();
                    }
                }
            };
        };
    }
    filterDropdownOnChange() {
        this.getData();
    }
    filterMultipleSelectorOnChange(_elem) {
        this.getData();
    }
    filterDateOnChange() {
        this.getData();
    }
}
